import { useTranslation } from '@clavian/i18n/react';
import { Link } from '@tanstack/react-router';

/** A page that does not exist, or a venue that is not the member's — the same answer (spec/08 §2.6). */
export function NotFound() {
  const { t } = useTranslation('console');
  return (
    <main className="console-centred" id="console-main">
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <p>
        <Link to="/venues">{t('notFound.home')}</Link>
      </p>
    </main>
  );
}
